import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Inspection, InspectionOrderField } from '../../shared/models';

@Component({
  selector: 'manager-inspection-list-table',
  templateUrl: './admin-list.component.html',
  standalone: false
})
export class ManagerInspectionListComponent {
  @Input() public inspections: Inspection[];
  @Output() public toggleSelectInspection: EventEmitter<any> = new EventEmitter();
  @Output() public toggleSort: EventEmitter<InspectionOrderField> = new EventEmitter();
  @Output() public toggleScroll: EventEmitter<InspectionOrderField> = new EventEmitter();
  @Output() public toggleReport: EventEmitter<Inspection> = new EventEmitter();
  @Input() orderBy: InspectionOrderField;
  inspectionOrderField = InspectionOrderField;
  extendedColumn = InspectionOrderField.ByEquipmentType;

  public selectInspection(inspection: Inspection) {
    this.toggleSelectInspection.emit(inspection);
  }

  public setOrderBy(newOrderBy: InspectionOrderField) {
    this.orderBy = Math.abs(this.orderBy) === newOrderBy ? -this.orderBy : newOrderBy;
    this.toggleSort.emit(this.orderBy);
  }

  scroll(event: Event) {
    const target = event.target as HTMLDivElement;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 600) {
      this.toggleScroll.emit();
    }
  }

  extend(event: Event, column) {
    event.stopPropagation();
    this.extendedColumn = column;
  }

  openReport(inspection: Inspection, event: Event) {
    event.stopPropagation();
    this.toggleReport.emit(inspection);
  }
}
